import type { RadioChangeEvent } from 'antd';
import { Radio }                 from 'antd';
import { RadioGroupProps }       from 'antd/es';
import FormattedMessageWrapper   from './FormattedMessageWrapper';

const RadioGroup = Radio.Group;

const options = [
  {
    label: <FormattedMessageWrapper id="Oui" />,
    value: true,
  },
  {
    label: <FormattedMessageWrapper id="Non" />,
    value: false,
  },
];

const YesOrNo = (props: RadioGroupProps & {
  disabled?: boolean;
  onChange?: (event: RadioChangeEvent) => void;
  value?: boolean;
}) => <RadioGroup size="large" options={options} {...props} />;

export default YesOrNo;
